import {
  push,
  RouterState
}                                 from "connected-react-router";
import React, { memo }            from 'react';
import {
  useDispatch,
  useSelector
}                                 from "react-redux";
import TriggersWrapperComponent from "../../../containers/TriggersComponentContainer";
import { ApplicationState }       from "../../../store";
import { cancelAllRequests }      from "../../../store/API/actions";
import { APIState }               from "../../../store/API/types";
import { Routes }                 from "../../../types";
import ListLayoutComponent        from "../../listlayout/ListLayoutComponent";
import { IconComponent }          from "../../reusable/simpleComponents";
import { ListUIComponent }        from "../../ui";
import AlertsUIComponent          from "../../ui/AlertsUIComponent";


const LeftsideUIWrapperComponent = () => {
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {cameras, privileges, serviceType} = useSelector<ApplicationState, APIState>(state => state.API);
  const canBrowse = privileges && privileges.canBrowse;
  const canViewBookmarks = privileges && privileges.canViewBookmarks;

  const dispatch = useDispatch();
  const path = location.pathname;

  const liveHandler = () => {
    if (path !== Routes.live) {
      dispatch(push('live'));
      dispatch(cancelAllRequests());
    }
  }
  const browseHandler = () => {
    if (path !== Routes.browse) {
      dispatch(push('browse'));
      dispatch(cancelAllRequests());
    }
  }
  const alertsHandler = () => {
    if (path !== Routes.alerts) {
      dispatch(push('alerts'));
      dispatch(cancelAllRequests());
    }
  }
  const bookmarksHandler = () => {
    if (path !== Routes.bookmarks) {
      dispatch(push('bookmarks'));
      dispatch(cancelAllRequests());
    }
  }

  return (
    <div style={{zIndex: 2}}>
      <ListLayoutComponent/>
      <div className='flex al-it-c'>
        <ListUIComponent/>
        <>
          <IconComponent
            handler={() => {
              liveHandler();
            }}
            classValue={path === Routes.live ? 'live-icon icon active' : 'live-icon icon'}
            title="Enter Live Mode"
          />
          {
            (cameras && canBrowse) && <IconComponent
              handler={() => {
                browseHandler();
              }}
              classValue={path === Routes.browse ? 'browse-icon icon active' : 'browse-icon icon'}
              title="Enter Browse Mode"
            />
          }
          {
            (cameras && canBrowse && canViewBookmarks && serviceType !== 2) && <IconComponent
              handler={() => {
                bookmarksHandler();
              }}
              classValue={path === Routes.bookmarks ? 'bookmarks-icon icon active' : 'bookmarks-icon icon'}
              title="Bookmarks"
            />
          }

          <AlertsUIComponent
            className={path === Routes.alerts ? 'alerts-icon icon active' : 'alerts-icon icon'}
            handler={() => {
              alertsHandler();
            }}
          />

          {
            path !== Routes.browse && <TriggersWrapperComponent/>
          }
        </>
      </div>
    </div>
  )
};

export default memo(LeftsideUIWrapperComponent);